import React from "react";
import PropTypes from "prop-types";
import { KeyboardDatePicker } from "@material-ui/pickers";

const FormDateField = ({
  input,
  label,
  disableFuture,
  meta: { touched, error },
  minDate,
  dateFormat = "DD.MM.YYYY",
  views,
  preserveTimezone = false,
}) => (
  <KeyboardDatePicker
    label={label}
    error={touched && error ? true : false}
    helperText={touched && error}
    margin="dense"
    minDate={minDate}
    disableFuture={disableFuture}
    InputLabelProps={{
      shrink: true,
    }}
    autoOk
    okLabel="OK"
    cancelLabel="Anuluj"
    clearLabel="Wyczyść"
    invalidLabel="Wybierz ..."
    onChange={(value) => input.onChange(value)}
    format={dateFormat}
    views={views}
    value={input.value ? (preserveTimezone ? input.value : input.value.toDate()) : null}
  />
);

FormDateField.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  minDate: PropTypes.object,
  disableFuture: PropTypes.bool,
  dateFormat: PropTypes.string,
  views: PropTypes.arrayOf(PropTypes.string),
  preserveTimezone: PropTypes.bool,
};

export default FormDateField;
